module.exports = "/fonts/MetaPro-Bold.woff?0e6f90b9124eaf803bb6cb1f6ef815d0";